export default "__VITE_ASSET__SUv_OkrS__"